import React from 'react';
import CreateCustomerState from './createCustomerState/CreateCustomerState';
import { ModalWindows } from './components/ModalWindows';
import { CustomerForm } from './components/CustomerForm';

export const CreateCustomerPageNewUi: React.FC = () => {
	return (
		<CreateCustomerState>
			<CustomerForm />
			<ModalWindows />
		</CreateCustomerState>
	);
};
